import React, { useEffect } from "react";
import AbtSchemeUI from '../component/AbtSchemeUI'
const AbtScheme = () => {
  useEffect(()=>{
    window.scrollTo(0,0)
  },[])
  return (
    <AbtSchemeUI/>
  );
};

export default AbtScheme;
